import { createApi } from '@reduxjs/toolkit/query/react';
import { createApiConfig } from '../../createApiConfig';

const unwrap = res => res.data;

export const aMIptvAnalyticsApi = createApi({
  reducerPath: 'aMIptvAnalyticsApi',
  ...createApiConfig(process.env.REACT_APP_API_BASE_URL),
  tagTypes: [
    'IPTV General Stats',
    'Top Pirated VOD',
    'Top Pirated Channels',
    'Per Month Reported Streams',
    'Streams Heatmap',
    'IPTV Stats Table',
    'Top Reported Streams',
  ],
  endpoints: builder => ({
    getIptvGeneralStats: builder.query({
      query: params => ({ url: '/analytics/iptv-general-stats/', params }),
      transformResponse: unwrap,
      providesTags: ['IPTV General Stats'],
    }),
    getTopPiratedVod: builder.query({
      query: params => ({ url: '/analytics/top-pirated-vod/', params }),
      transformResponse: unwrap,
      providesTags: ['Top Pirated VOD'],
    }),
    getTopPiratedChannels: builder.query({
      query: params => ({ url: '/analytics/top-pirated-channels/', params }),
      transformResponse: unwrap,
      providesTags: ['Top Pirated Channels'],
    }),
    getPerMonthReportedStreams: builder.query({
      query: params => ({ url: '/analytics/per-month-reported-streams/', params }),
      transformResponse: unwrap,
      providesTags: ['Per Month Reported Streams'],
    }),
    getStreamsHeatmap: builder.query({
      query: () => ({ url: '/analytics/streams-heatmap/' }),
      transformResponse: res => {
        const inner = unwrap(res);
        return Array.isArray(inner) ? inner : [];
      },
      providesTags: ['Streams Heatmap'],
    }),
    getIptvStatsTable: builder.query({
      query: params => ({ url: '/analytics/iptv-stats-table/', params }),
      transformResponse: res => {
        const inner = unwrap(res);
        return Array.isArray(inner) ? inner : [];
      },
      providesTags: ['IPTV Stats Table'],
    }),
    getTopReportedStreams: builder.query({
      query: params => ({ url: '/analytics/top-reported-streams/', params }),
      transformResponse: res => {
        const inner = unwrap(res);
        return inner && typeof inner === 'object' && !Array.isArray(inner) ? inner : {};
      },
      providesTags: ['Top Reported Streams'],
    }),
    getIptvReportedIpsPerApp: builder.query({
      query: params => ({ url: '/analytics/iptv-reported-ips-per-app/', params }),
      transformResponse: unwrap,
      providesTags: ['IPTV General Stats'],
    }),
  }),
});

export const {
  useGetIptvGeneralStatsQuery,
  useGetTopPiratedVodQuery,
  useGetTopPiratedChannelsQuery,
  useGetPerMonthReportedStreamsQuery,
  useGetStreamsHeatmapQuery,
  useGetIptvStatsTableQuery,
  useGetTopReportedStreamsQuery,
  useGetIptvReportedIpsPerAppQuery,
} = aMIptvAnalyticsApi;
